/*
 * Project: bellcloud
 * File: packages/types/device/common/constraints.ts
 * Author: SWAN
 * Created: 2025-01-27
 * Description: Common constraint interfaces and shared constants
 * Lite와 Mini 디바이스 공통으로 사용되는 타입 정의 및 공통 상수
 */

import { GasConcUnit } from './gas_conc_unit';
export { GAS_CONC_SCALE } from '../../../protocols/constants';

export interface Ranges {
  default?: number;
  ranges: [number, number][];
  scale?: number;
  unit?: 'sec' | 'days' | 'min' | 'hours' | '%';
}

/**
 * 기본 센서 제약조건 인터페이스
 * Lite와 Mini 공통으로 사용되는 필드들
 */
export interface BaseSensorConstraints {
  calibration_gas_conc?: Ranges;
  calibration_interval?: Ranges;
  bump_interval?: Ranges;
  low_alarm?: Ranges;
  high_alarm?: Ranges;
  gas_conc_unit?: GasConcUnit;
  twa_alarm?: Ranges;
  stel_alarm?: Ranges;
  stel_period?: Ranges;
  twa_period?: Ranges;
  auto_fresh?: 0 | 1;
  bump_test_threshold?: Ranges; // 40~100 (%), O2/O2LF는 40으로 고정
}

/**
 * NO_SENSOR (센서 없음) 제약조건
 * Lite와 Mini 공통으로 사용
 */
export const NO_SENSOR_CONSTRAINTS: BaseSensorConstraints = {
  calibration_interval: { default: 180, ranges: [[0, 365]], unit: 'days' },
  bump_interval: { default: 0, ranges: [[0, 365]], unit: 'days' },
  calibration_gas_conc: { default: 0, ranges: [[0, 0]], scale: 1 },
  low_alarm: { default: 0, ranges: [[0, 0]], scale: 1 },
  high_alarm: { default: 0, ranges: [[0, 0]], scale: 1 },
  gas_conc_unit: GasConcUnit.PPM,
  twa_alarm: { default: 0, ranges: [[0, 0]], scale: 1 },
  stel_alarm: { default: 0, ranges: [[0, 0]], scale: 1 },
  stel_period: { default: 0, ranges: [[0, 0]], unit: 'min' },
  twa_period: { default: 0, ranges: [[0, 0]], unit: 'hours' },
  auto_fresh: 0,
};
